import { ErrorBoundary, Logo } from "@hubcapp/components";
import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    background: theme.palette.background.dark,
  },
  logo: {
    margin: `${theme.spacing(2)}px 0 0 ${theme.spacing(2)}px`,
  },
  main: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4, 2, 4, 2),
  },
}));

const Auth: React.FC = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <header>
        <Logo rootClass={classes.logo} />
      </header>
      <main className={classes.main}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
    </div>
  );
};

export default Auth;
